import { render, staticRenderFns } from "./CentralSide.vue?vue&type=template&id=0d602762"
import script from "./CentralSide.vue?vue&type=script&lang=js"
export * from "./CentralSide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports